import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Button, Modal } from 'antd';
import { TRANSLATION_NAMESPACES } from 'util/translation/constant';
import PropTypes from 'prop-types';
import * as selector from '../state/selector';
import { VNC_SESSION_STATUS } from '../util/constant';

export const MachineVncStatusModal = ({ onClose }) => {
  const { t } = useTranslation(TRANSLATION_NAMESPACES.MACHINE_DETAILS);

  const { machineVncSession } = useSelector((state) => ({
    machineVncSession: selector.selectMachineVncSession(state)
  }));

  const { status, modal, cachedSessionStatus } = machineVncSession;

  const isStatusFailed =
    status.statusResponse.includes(VNC_SESSION_STATUS.FAILED) &&
    status.code &&
    status.code.length > 0;

  const isCachedStatusFailed =
    cachedSessionStatus.data === VNC_SESSION_STATUS.FAILED &&
    cachedSessionStatus.code &&
    cachedSessionStatus.code.length > 0;

  const getStatusDescriptionDetails = useCallback(() => {
    if (isStatusFailed || isCachedStatusFailed) {
      return status.code.map((c) => `machineVncStatusModal.description.${c}`);
    }

    return `machineVncStatusModal.description.generalFailedDescription`;
  }, [isCachedStatusFailed, isStatusFailed, status.code]);

  return (
    <Modal
      title={t('machineVncStatusModal.title')}
      open={modal.status.visible}
      className="base-modal no-select"
      closable={false}
      width={550}
      destroyOnClose
      footer={[
        <Button className="cancel-btn" onClick={onClose}>
          {t('machineVncStatusModal.backButton')}
        </Button>
      ]}>
      <pre className="machine-vnc-status-modal whitespace-normal">
        {t(getStatusDescriptionDetails())}
      </pre>
    </Modal>
  );
};

MachineVncStatusModal.propTypes = {
  onClose: PropTypes.func.isRequired
};
